<template>
  <div class="container email-like">
    <div class="card">
      <div class="card-header">
        Se detectó un error {{ firstMessageLine }} - {{ customerName }}
      </div>
      <div class="card-body">
          <div class="meta d-flex align-items-center" style="gap: 8px;">
            <strong>Estado:</strong>
            <select v-model="editable.Status" @change="emitUpdate('Status')" class="form-control form-control-sm d-inline-block w-auto">
              <option value="OPEN">Abierto</option>
              <option value="RESOLVED">Resuelto</option>
              <option value="IGNORED">Ignorado</option>
            </select>
          </div>
        <div class="meta"><strong>URL:</strong> <a :href="errorLog.URL" target="_blank">{{ errorLog.URL }}</a></div>
        <div class="meta"><strong>Usuario:</strong> <span>{{ errorLog.User || 'Usuario desconocido' }}</span></div>
        <div class="meta"><strong>Dispositivo:</strong> <span>{{ errorLog.Device || 'Dispositivo desconocido' }}</span></div>
        <div class="meta"><strong>Navegador:</strong> <span>{{ errorLog.Browser || 'Navegador desconocido' }}</span></div>
        <div class="meta"><strong>Cliente:</strong> <span>{{ customerName }}</span></div>
        <div class="meta"><strong>Archivo:</strong> <span>{{ editable.File }}</span></div>
        <div class="meta"><strong>LastSeen:</strong> <span>{{ editable.LastSeen }}</span></div>
        <div class="section" v-if="stackText">
          <h4>Mensaje</h4>
          <pre>{{ editable.Message }}</pre>
        </div>
        <div class="section" v-if="stackText">
          <h4>Stack trace</h4>
          <pre>{{ stackText }}</pre>
        </div>
        <div class="section" v-if="errorLog.Logs">
          <h4>Logs</h4>
          <pre>{{ parsedLogs.join('\n') }}</pre>
        </div>
        <div class="section">
          <h4 class="d-flex align-items-center" style="gap:8px;">
            JSON completo (debug)
            <button @click="copyDebugJSON" type="button" class="btn btn-sm btn-outline-secondary">Copiar</button>
          </h4>
          <pre>{{ debugJSONString }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Status } from '@sentry/browser';
import { mapState } from 'vuex';

export default {
  name: 'error-logs-edit-modal',
  props: {
    record: { type: Object, required: true }
  },
  data () {
    return {
      editable: {
        Message: this.record.Message || '',
        File: this.record.File || '',
        LastSeen: this.record.LastSeen || '',
        Status: this.record.Status || '',
      }
    }
  },
  computed: {
    ...mapState({
        recordStore: state => state.main.record,
    }),
    errorLog () {
      return (this.record.ErrorLogs && this.record.ErrorLogs.length > 0)
        ? this.record.ErrorLogs[0]
        : {};
    },
    customerName () {
      const c = this.errorLog.Customer;
      if (!c) return 'Cliente no identificado';
      if (typeof c === 'string') return c;
      return c.Name || c.name || 'Cliente no identificado';
    },
    formattedTimestamp () {
      const raw = this.errorLog.CreatedUTCRaw || this.errorLog.CreatedUTC;
      try {
        return raw ? new Date(raw).toLocaleString() : '';
      } catch (e) {
        return this.errorLog.CreatedUTC ? String(this.errorLog.CreatedUTC) : '';
      }
    },
    stackText () {
      const s = this.errorLog.Stack || '';
      if (!s) return '';
      return s.split('\n').filter(x => x && x.trim()).join('\n');
    },
    firstMessageLine () {
      const s = this.errorLog.Stack || '';
      if (!s) return 'Mensaje de error no disponible';
      const first = s.split('\n')[0];
      return first || 'Mensaje de error no disponible';
    },
    parsedLogs() {
      try {
        if (Array.isArray(this.errorLog.Logs)) return this.errorLog.Logs;
        return JSON.parse(this.errorLog.Logs);
      } catch (e) {
        return [this.errorLog.Logs];
      }
    },
    debugJSON() {
      return {
        url: this.errorLog.URL || '',
        error: {
          message: this.editable.Message || this.firstMessageLine,
          stack: this.errorLog.Stack ? this.errorLog.Stack.split('\n').filter(l => l && l.trim()) : [],
          logs: typeof this.errorLog.Logs === 'string'
            ? this.errorLog.Logs
            : (this.errorLog.Logs ? JSON.stringify(this.errorLog.Logs) : '')
        },
        user: this.errorLog.User || null,
        device: this.errorLog.Device || null,
        browser: this.errorLog.Browser || null,
        customer: this.customerName || null,
        timestamp: this.errorLog.CreatedUTCRaw || this.errorLog.CreatedUTC || null
      }
    },
    debugJSONString() {
      try {
        return JSON.stringify(this.debugJSON, null, 2);
      } catch (e) {
        return '{}';
      }
    }
  },
  methods: {
    async emitUpdate (field) {
      await api.post('/api/errorsignature/status/' + this.recordStore.id, JSON.stringify({ Status: this.editable.Status }));
    },
    async copyDebugJSON() {
      try {
        await navigator.clipboard.writeText(this.debugJSONString);
        this.$emit('copied-debug-json');
      } catch (e) {
        console.error('No se pudo copiar el JSON de debug', e);
      }
    }
  }
}

</script>

<style scoped>
.modal-dialog{
    overflow-y: initial !important
}
.email-like{max-width:760px;margin:16px auto;padding:0 12px}
.email-like .card{background:#ffffff;border:1px solid #e5e7eb;border-radius:10px;box-shadow:0 2px 6px rgba(0,0,0,0.06);overflow:hidden}
.email-like .card-header{background:#0ea5e9;color:#fff;padding:14px 18px;font-weight:600;font-size:16px}
.email-like .card-body{padding:18px}
.email-like .meta{display:block;margin:0 0 10px 0}
.email-like .meta strong{color:#111827}
.email-like .meta a{color:#0ea5e9;text-decoration:none;word-break:break-all}
.email-like .section{margin-top:14px}
.email-like .section h4{margin:0 0 8px 0;font-size:14px;color:#111827}
.email-like pre{background:#0f172a;color:#e5e7eb;border-radius:8px;border:1px solid #111827;padding:12px;overflow:auto;white-space:pre-wrap;word-wrap:break-word;font-family:ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, monospace;font-size:12px;line-height:1.45}
.email-like .pill{display:inline-block;background:#eef2ff;color:#3730a3;border:1px solid #c7d2fe;border-radius:999px;padding:2px 10px;font-size:12px}
</style>
